import script from "./terminal.vue?vue&type=script&setup=true&lang=js"
export * from "./terminal.vue?vue&type=script&setup=true&lang=js"

import "./terminal.vue?vue&type=style&index=0&id=16931ff4&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16931ff4"]])

export default __exports__